import React from "react";
import {
  Chip,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CampaignIcon from "@mui/icons-material/Campaign";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import PeopleIcon from "@mui/icons-material/People";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useLocation, useNavigate, Link as RouterLink } from "react-router-dom";

const items = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: <DashboardIcon />,
    to: "/dashboard",
  },

  {
    key: "scheduler",
    label: "Scheduler",
    icon: <CalendarMonthIcon />,
    to: "/dashboard/scheduler",
  },
  {
    key: "products",
    label: "Products",
    icon: <StorefrontIcon />,
    to: "/dashboard/products",
  },
  {
    key: "inventory",
    label: "Inventory",
    icon: <Inventory2Icon />,
    to: "/dashboard/inventory",
    beta: true,
  },
  {
    key: "orders",
    label: "Orders",
    icon: <ShoppingCartIcon />,
    to: "/dashboard/orders",
  },
  {
    key: "shipping",
    label: "Shipping",
    icon: <LocalShippingIcon />,
    to: "/dashboard/shipping",
    badge: "New",
  },
  {
    key: "campaigns",
    label: "Campaigns",
    icon: <CampaignIcon />,
    to: "/dashboard/campaigns",
    badge: "New",
  },
  {
    key: "customers",
    label: "Customers",
    icon: <PeopleIcon />,
    to: "/dashboard/customers",
  },
  {
    key: "finance",
    label: "Finance",
    icon: <AccountBalanceIcon />,
    to: "/dashboard/finance",
  },
  {
    key: "auto-comment",
    label: "AI Assistant",
    icon: <SmartToyIcon />,
    to: "/dashboard/auto-comment",
    badge: "New",
  },
  {
    key: "marketing",
    label: "Marketing",
    icon: <TrendingUpIcon />,
    to: "/dashboard/marketing",
    beta: true,
  },
  {
    key: "ai",
    label: "Creative Studio",
    icon: <AutoFixHighIcon />,
    to: "/dashboard/ai",
    beta: true,
  },
  {
    key: "billing",
    label: "Billing",
    icon: <CreditCardIcon />,
    to: "/dashboard/billing",
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    icon: <WhatsAppIcon />,
    to: "/dashboard/whatsapp",
  },
  {
    key: "settings",
    label: "Settings",
    icon: <SettingsIcon />,
    to: "/dashboard/settings",
  },
  {
    key: "help",
    label: "Help",
    icon: <HelpOutlineIcon />,
    to: "/dashboard/help",
  },
];

export default function SidebarNav({ onNavigate }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (to) => {
    return location.pathname === to;
  };

  const handleNavigate = (to) => {
    if (onNavigate) {
      onNavigate(to);
      return;
    }
    navigate(to);
  };

  return (
    <div className="w-full h-full flex flex-col bg-white dark:bg-gray-800">
      <nav className="flex-1 overflow-y-auto py-4 px-3">
        {items.map((item) => {
          const active = isActive(item.to);
          return (
            <div key={item.key} className="mb-1">
              <RouterLink
                to={item.to}
                onClick={() => handleNavigate(item.to)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                  active
                    ? "bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400 shadow-sm"
                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50"
                }`}
              >
                <div
                  className={`flex-shrink-0 ${
                    active
                      ? "text-primary-600 dark:text-primary-400"
                      : "text-gray-500 dark:text-gray-400"
                  }`}
                >
                  {item.icon}
                </div>
                <span className={`font-medium flex-1 ${active ? "text-primary-600 dark:text-primary-400" : ""}`}>
                  {item.label}
                </span>
                {item.beta && (
                  <Chip
                    label="Beta"
                    size="small"
                    className="h-5 text-[0.65rem] font-semibold bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300"
                  />
                )}
                {item.badge && (
                  <Chip
                    label={item.badge}
                    size="small"
                    className="h-5 text-[0.65rem] font-semibold bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300"
                  />
                )}
              </RouterLink>
            </div>
          );
        })}
      </nav>
    </div>
  );
}
